import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-first-login-dialog',
    templateUrl: './first-login-dialog.component.html',
    styleUrls: ['./first-login-dialog.component.scss'],
    standalone: false
})
export class FirstLoginDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<FirstLoginDialogComponent>) {}


  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }
}
